module.exports = __webpack_public_path__ + "static/media/good-memoji.24a674f2.png";